var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.2 15.3125C28.2 14.3375 28.1125 13.4 27.95 12.5H15V17.8188H22.4C22.0812 19.5375 21.1125 20.9938 19.6562 21.9688V25.4187H24.1C26.7 23.025 28.2 19.5 28.2 15.3125Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9999 28.75C18.7124 28.75 21.8249 27.5187 24.0999 25.4187L19.6562 21.9687C18.4249 22.7937 16.8499 23.2812 14.9999 23.2812C11.4187 23.2812 8.3874 20.8625 7.30615 17.6125H2.7124V21.175C4.9749 25.6687 9.6249 28.75 14.9999 28.75Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.30625 17.6125C7.03125 16.7875 6.875 15.9063 6.875 15C6.875 14.0938 7.03125 13.2125 7.30625 12.3875V8.82501H2.7125C1.75 10.7411 1.24915 12.8558 1.25 15C1.25 17.2188 1.78125 19.3188 2.7125 21.175L7.30625 17.6125Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9999 6.71875C17.0186 6.71875 18.8311 7.4125 20.2561 8.775L24.1999 4.83125C21.8186 2.6125 18.7061 1.25 14.9999 1.25C9.6249 1.25 4.9749 4.33125 2.7124 8.825L7.30615 12.3875C8.3874 9.1375 11.4186 6.71875 14.9999 6.71875Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.e6989d8607d2af3cce719dee5c506747.svg";
export { ForwardRef as ReactComponent };